import { render } from "./gift-wrap.vue?vue&type=template&id=e74f9228"
import script from "./gift-wrap.vue?vue&type=script&lang=js"
export * from "./gift-wrap.vue?vue&type=script&lang=js"

import "./gift-wrap.vue?vue&type=style&index=0&id=e74f9228&lang=scss"

import exportComponent from "/Users/ashley.eastham/Fostr Dev/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__